import { Turnstile } from '@marsidev/react-turnstile';
import React, { useState, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'reactstrap';

import { useConfig } from '../../../_components/config';
import { useThemeContext } from '../../../app/theme-provider';

import styles from './styles.module.scss';

export default function Submit({ handleSubmit }: { handleSubmit: () => void }) {
  const { cloudflareTurnstileKey } = useConfig();
  const { theme } = useThemeContext();
  const [canSubmit, setCanSubmit] = useState(false);
  const {
    formState: { isValid, isSubmitting },
  } = useFormContext();

  const vappDescription = (
    <div className={`${styles.alert} alert alert-info`}>
      Community providers should use the VA Precertification Portal (VAPP) to
      determine, create, and submit services that require precertification to VA
      prior to rendering those services. Upon successful completion of a
      precertification notification in the VAPP, the provider will receive a
      unique precertification ID via email at the time of submission.
    </div>
  );

  const captchaRef = useRef();
  const disabled = !canSubmit || isSubmitting || !isValid;

  return (
    <>
      {vappDescription}

      <Button
        data-testid="submit-request"
        color="success"
        size="lg"
        className={
          disabled
            ? `${styles.btnDisabled} mx-auto mt-2 mb-3`
            : `${styles.btnEnabled} mx-auto mt-2 mb-3`
        }
        aria-disabled={disabled}
        aria-label="Submit Request"
        onClick={handleSubmit}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            handleSubmit();
            event.preventDefault();
          }
        }}
      >
        Submit
      </Button>
      <div role="region" aria-label="Security Area">
        <Turnstile
          ref={captchaRef}
          options={{
            theme: theme,
          }}
          siteKey={cloudflareTurnstileKey}
          onError={() => setCanSubmit(false)}
          onExpire={() => setCanSubmit(false)}
          onSuccess={() => setCanSubmit(true)}
        />
      </div>
    </>
  );
}
